import requests from './httpService';
import { appendRoleQuery } from '../../../../utils/activityCatalogScope';

const SuperActivityTabelService = {
  getAllSuperActivity(id, role) {
    return requests.get(appendRoleQuery(`/superactivity/list/${id}`, role));
  },
  getStudentSuperActivity(id, role) {
    return requests.get(appendRoleQuery(`/superactivity/list/${id}`, role));
  },
  getAllSuperActivityById(id, body, role) {
    return requests.post(appendRoleQuery(`/superactivity/list/${id}`, role), body);
  },
//   upadeCity(body) {
//     return requests.put(`/city/${body.id}`,body); 
//   },
  creteSuperActivity(body){
    return requests.post('/superactivity/add',body); 
  },
//   getAllSuperActivityTabelMultiple(body) {
//   return requests.get(`/superactivity/list/multiple/${classId}`, body);
// },
getAllSuperActivityTabelMultiple( body) {
  return requests.post(`/superactivity/multiple`, body);
},

  // getAllSuperActivityTabelMultiple(id) {
  //   return requests.get(`/superactivity/list/multiple/${id}`);
  // },
  deleteSuperActivity(body){
    return requests.delete(`/superactivity/${body._id}`); 
  },
//   getAllCoupon() {
//     return requests.get('/coupon');
//   },
// getAllAddClass() {
//   return requests.get('/addclass');
// },
  upadeSuperActivity(body) {
    return requests.put(`/superactivity/${body._id}`,body); 
  },
//   creteCoupon(body){
//     return requests.post('/coupon/add',body); 
//   },
//   deleteCoupon(body){
//     return requests.delete(`/coupon/${body._id}`); 
//   },
//   createVendorOrdersById(body){
//     return requests.post('/orders/getvendororders',body); 
//   },

//   getAllVendorList() {
//     return requests.get('/vendorlist');
//   },

};

export default SuperActivityTabelService;
